module.exports = __webpack_public_path__ + "img/ad_coupon_4@2x.d06be616.png";